(function () {
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  }

  function initPopup(popup) {
    var cookieName = 'newsletter_popup_dismissed_' + popup.id;
    var hideDays = parseInt(popup.dataset.hideDays, 10) || 7;
    var delay = parseInt(popup.dataset.delay, 10) || 0;

    if (getCookie(cookieName)) return;

    // If the form already posted back with a Shopify error/success, show immediately.
    var hasFormResult = popup.querySelector('.newsletter-popup__error, .newsletter-popup__success');
    var hasSuccess = popup.querySelector('.newsletter-popup__success');
    var autoCloseDelay = 3500;

    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setCookie(cookieName, '1', hideDays);
    }

    popup.querySelectorAll('[data-newsletter-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    var overlay = popup.querySelector('[data-newsletter-popup-overlay]');
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (hasFormResult) {
      open();
      if (hasSuccess) setTimeout(close, autoCloseDelay);
    } else {
      setTimeout(open, delay);
    }
  }

  document.querySelectorAll('[data-newsletter-popup]').forEach(initPopup);
})();
